import ArrowIconThick from 'assets/images/arrows/arrowIconThick.svg?react';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ExpandButton } from 'shared/components/form/expandButton';
import { isMobile } from 'shared/util/utility';
import './styles.scss';

interface Props {
	className?: string;
	isExpanded: boolean;
	handleExpand: any;
	eventUrl?: any;
	gamesCount?: number;
	isEventExpandable: boolean;
}

const OddsExpander: React.FC<Props> = ({ isExpanded, handleExpand, eventUrl, gamesCount, isEventExpandable }) => {
	const { t } = useTranslation();
	const expanderText = isExpanded ? 'Zwiń' : 'Rozwiń';

	const handleButton = (e: any) => {
		handleExpand(e);
	};

	const renderIcon = (
		<div className={cn('oddsExpander__icon', { 'oddsExpander__icon--rotated': isExpanded })}>
			<ArrowIconThick />
		</div>
	);

	if (!isEventExpandable) {
		return <></>;
	}

	return isMobile() ? (
		<div className={cn('oddsExpander', { 'oddsExpander--single': !eventUrl }, { 'oddsExpander--expanded': isExpanded })}>
			<motion.button
				initial={{ width: '100%' }}
				animate={{ width: isExpanded ? '50%' : '100%' }}
				transition={{
					ease: 'easeOut',
					duration: 0.3,
				}}
				onClick={handleButton}
				className="oddsExpander__button"
			>
				{renderIcon} {expanderText}
			</motion.button>
			<AnimatePresence>
				{isExpanded && eventUrl && (
					<motion.div
						className="oddsExpander__link"
						initial={{ x: '300px' }}
						animate={{ x: 0 }}
						exit={{ x: '300px' }}
						transition={{ ease: 'linear', duration: 0.3 }}
					>
						<Link to={eventUrl()}>{`${t('more')} (+${gamesCount})`}</Link>
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	) : (
		<ExpandButton onClick={handleExpand} isExpanded={isExpanded} />
	);
};

export default OddsExpander;
